import { Outlet } from 'react-router-dom'
import { PageErrorBoundary } from './PageErrorBoundary'
import { DashboardBreadcrumbProvider } from './DashboardBreadcrumbContext'
import { SecurityNotificationBanner } from '@/components/SecurityNotificationBanner'
import '@/components/SecurityNotificationBanner/securityNotificationBanner.css'
import type { BaseDashboardLayoutProps } from './BaseDashboardLayout.types'

/**
 * Base dashboard layout component
 * Shared layout structure for both admin and applicant dashboards
 */
export function BaseDashboardLayout({
  sidebar,
  sidebarWidth = 'lg:ml-16',
  beforeMain,
}: BaseDashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Angular LayoutComponent — security toast only after dashboard shell is mounted (post-login). */}
      <SecurityNotificationBanner />
      {sidebar}
      <div className={`${sidebarWidth} min-w-0 transition-all duration-300 pt-14 lg:pt-0 safe-area-top`}>
        {beforeMain}
        <main className="min-h-screen min-w-0 w-full max-w-full">
          <DashboardBreadcrumbProvider>
            <PageErrorBoundary>
              <Outlet />
            </PageErrorBoundary>
          </DashboardBreadcrumbProvider>
        </main>
      </div>
    </div>
  )
}
